module.exports = __webpack_public_path__ + "media/images/contacto/mail-5135d78d52f5fa742121643563eb4624.svg";